import React from "react";
import "./Projects.css";

const AnimatedFlexCards = () => {
  return (
    <div className="wrapper">
      <div className="container">
        <input type="radio" name="slide" id="c1" defaultChecked />
        <label htmlFor="c1" className="card">
          <div className="row">
            <div className="icon">1</div>
            <div className="description">
              <h4>
                <a
                  href="https://algorithm-visualizer-show-case.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Data Structures & Algorithms Visualizer • Click here for the
                  project
                </a>
              </h4>
              <p>
                Explore different data structures and algorithms through an
                interactive visualizer. Learn sorting, pathfinding, and more
                with this web app.
              </p>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c2" />
        <label htmlFor="c2" className="card">
          <div className="row">
            <div className="icon">2</div>
            <div className="description">
              <h4>
                <a
                  href="https://live-chord.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Live Chord Identifier • Click here for the project
                </a>
              </h4>
              <p>
                Identify piano chords in real time with this live audio chord
                detection app. Powered by Web Audio API and React.
              </p>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c3" />
        <label htmlFor="c3" className="card">
          <div className="row">
            <div className="icon">3</div>
            <div className="description">
              <h4>
                <a
                  href="https://amazon-scraper-show-case.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Amazon Price Tracker Web Scraper • Click here for the project
                </a>
              </h4>
              <p>
                This web app scrapes Amazon to track prices. Set your desired
                price, and get email notifications when the price drops to your
                preference.
              </p>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c4" />
        <label htmlFor="c4" className="card">
          <div className="row">
            <div className="icon">4</div>
            <div className="description">
              <h4>
                <a
                  href="https://hand-gesture-deployable.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Hand Gesture Mouse Control • Click here for the project
                </a>
              </h4>
              <p>
                Computer vision project to control your mouse using hand
                gestures with real-time webcam tracking powered by MediaPipe and
                React.
              </p>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c5" />
        <label htmlFor="c5" className="card">
          <div className="row">
            <div className="icon">5</div>
            <div className="description">
              <h4>
                <a
                  href="https://halal-restaurant-finder-showcase.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Halal Restaurant Finder • Click here for the project
                </a>
              </h4>
              <p>
                Discover nearby halal restaurants with ease. Filter by location,
                cuisine type, and ratings. A must-have tool for halal dining
                enthusiasts.
              </p>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default AnimatedFlexCards;
